import { render, staticRenderFns } from "./peopleMail-info.vue?vue&type=template&id=244b11bd&scoped=true&"
import script from "./peopleMail-info.vue?vue&type=script&lang=js&"
export * from "./peopleMail-info.vue?vue&type=script&lang=js&"
import style0 from "./peopleMail-info.vue?vue&type=style&index=0&lang=css&"
import style1 from "./peopleMail-info.vue?vue&type=style&index=1&id=244b11bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244b11bd",
  null
  
)

export default component.exports